module.exports = __webpack_public_path__ + "img/05.b5a5b634.png";